import { css, cva } from '@/styled-system/css';
import { styled } from '@/styled-system/jsx';

import { Box } from '@zillow/constellation-10';

export const BannerBox = styled(Box, {
  base: {
    marginBlock: '400',
    marginInline: 'auto',
    boxSizing: 'content-box',
  },
  variants: {
    isEnterpriseCustomer: {
      true: {},
      false: {
        // Non-enterprise view has banners outside of Page.Content, so we need to duplicate spacing
        maxWidth: 'Page.width.max',
        paddingInline: {
          base: 'Page.padding.horz.mobile',
          md: 'Page.padding.horz.tablet',
          xl: 'Page.padding.horz.desktop',
        },
      },
    },
  },
});

export const flexContainerStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  minHeight: '28px',
  justifyContent: 'space-evenly',
  gap: '{spacing.400} 0',
  lg: {
    justifyContent: 'space-between',
    flexDirection: 'row',
    margin: '{spacing.400} {spacing.400}',
  },
});

export const rightSubFlexContainerStyles = css.raw({
  display: 'flex',
  flexGrow: 2,
  justifyContent: 'center',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  alignItems: 'center',
  order: 0,
  width: '100%',
  lg: {
    order: 5,
    justifyContent: 'flex-end',
  },
});

export const stickySubHeadingSectionContainerRecipe = cva({
  base: {
    top: 0,
    left: 0,
    width: '100%',
    zIndex: 3,
  },
  variants: {
    isVisible: {
      true: {
        /*
         * if placeholder is visible, then is static
         */
        position: 'static',
        boxShadow: '0',
        xl: {
          left: 0,
          width: '100%',
        },
      },
      false: {
        /*
         * else fixed
         */
        position: 'fixed',
        boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.26)',
        borderBottom: '1px solid {colors.border.subtle}',
        backgroundColor: 'bg.neutral',
        xl: {
          left: '{sizes.leftNavWidth}',
          width: 'calc(100% - {sizes.leftNavWidth})',
        },
      },
    },
  },
});
